import { useTheme } from "styled-components";
import { useLanguageContext } from "../../../../context/LanguageContext";
import EVAApiHelper from "../../../../helpers/EVAApiHelper";
import FileHelper from "../../../../helpers/FileHelper";
import {
  StyledFlexColumn,
  StyledFlexItem,
  StyledFlexRow,
} from "../../../../styles/LayoutStyles";
import FilePreview from "../../../filePreview/FilePreview";
import InputWrapper from "../../../input/wrapper/InputWrapper";
import Select from "../../../select/main/Select";
import FlowPlayerControls from "../../controls/FlowPlayerControls";

function QuestionnaireStepView({
  controller,
  questions,
  fetchedQuestionnaireData,
  answeredQuestions,
  forceAnswer,
  setForceAnswer,
  onQuestionAnswerChange,
}) {
  const { translateEntity, translate } = useLanguageContext();
  const theme = useTheme();

  return (
    <FlowPlayerControls controller={controller}>
      <StyledFlexColumn>
        {fetchedQuestionnaireData &&
          answeredQuestions.length <= 0 &&
          !forceAnswer && (
            <>
              <p>
                {translate(
                  "eva.frontoffice.pages.visitor_type.steps.questionnaire.already_accepted",
                )}
              </p>

              <p onClick={() => setForceAnswer(true)}>
                {translate(
                  "eva.frontoffice.pages.visitor_type.steps.questionnaire.force_accept",
                  [
                    {
                      key: "questionnaire",
                      value: (
                        <span
                          style={{
                            fontWeight: "bold",
                            color:
                              theme["settings.button.color.primary.background"],
                          }}
                        >
                          {translate(
                            "eva.frontoffice.pages.visitor_type.steps.questionnaire.label",
                          ).toLowerCase()}
                        </span>
                      ),
                    },
                  ],
                )}
              </p>
            </>
          )}

        {(!fetchedQuestionnaireData ||
          forceAnswer ||
          answeredQuestions.length > 0) &&
          questions
            .sort((a, b) => a.order - b.order)
            .map((question) => (
              <InputWrapper
                key={question.id}
                label={translateEntity(question, "question")}
                required
                error={EVAApiHelper.getResponseError(
                  `question_${question.id}`,
                  controller.errors,
                )}
              >
                <StyledFlexRow
                  style={{ alignItems: "center", flexWrap: "nowrap" }}
                >
                  {question.image && (
                    <FilePreview
                      path={FileHelper.apiPath(
                        translateEntity(question.image, "path"),
                      )}
                    />
                  )}

                  <StyledFlexItem>
                    <Select
                      sort={false}
                      options={question.answers
                        .sort((a, b) => a.order - b.order)
                        .map((answer) => ({
                          value: answer.id,
                          label: translateEntity(answer, "answer"),
                        }))}
                      value={
                        controller.visitorData[`question_${question.id}`] ||
                        null
                      }
                      onChange={(value) =>
                        onQuestionAnswerChange(question, value)
                      }
                    />
                  </StyledFlexItem>
                </StyledFlexRow>
              </InputWrapper>
            ))}
      </StyledFlexColumn>
    </FlowPlayerControls>
  );
}

export default QuestionnaireStepView;
